<template>
  <div>
    <v-flex>
      <h1 class="headline1">المنصة الرقمية لشركة تطوير للنقل (رافد)</h1>
    </v-flex>
    <div class="d-flex justify-center">
        <div class=" login-card"  :style="{ backgroundImage: 'url(\'' + image + '\')' }">
      <v-card class="elevation-0 login-card-inner">
        <v-toolbar color="white"  flat>
          <v-toolbar-title>تسجيل الدخول</v-toolbar-title>
          <div class="flex-grow-1"></div>
        </v-toolbar>
        <v-card-text>
          <v-form>
            <v-text-field
              label="اسم المستخدم"
              name="login"
              prepend-icon="mdi-account"
              type="text"
              v-model="username"
            ></v-text-field>

            <v-text-field
              v-model="password"
              id="password"
              label="كلمة المرور"
              name="password"
              prepend-icon="mdi-textbox-password"
              type="password"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn ref="lgin" color="primary" @click="doLogin" >الدخول</v-btn>
        </v-card-actions>
      </v-card>
        </div>
    </div>

    <v-snackbar v-model="snackbar" timeout="3000">
      {{ errorText }}
      <v-btn color="pink" text @click="snackbar = false">إغلاق</v-btn>
    </v-snackbar>
  </div>
</template>


<script>

import cardBg from '../assets/images/login-box.png'
import alasql from "alasql";
import _ from "lodash";
export default {
  data: () => {
    return {
        image: cardBg,
      snackbar: false,
      errorText: "اسم المستخدم أو كلمة المرور غير صحيحة"
    };
  },   mounted() { 
    debugger;
    this.$refs.lgin.$el.autofocus=true;
  },
  methods: {
 
    async doLogin() {
      console.log("this.username", this.username);
      let requestBody = { username: this.username, password: this.password };
      let res = await fetch("https://sso-api.tatweertransit.com/token", {
        headers: { "content-type": "application/json" },
        referrer: "https://ods.tatweertransit.com/",
        body: JSON.stringify(requestBody),
        method: "POST",
        mode: "cors"
      });

      let json = await res.json();
      if (json.message == "OK") {
        localStorage.setItem("token", json.token2);
        console.log("valid login :) ");
        this.$store.dispatch("setUser", json);
        //set time out 3 @todo
        //this.loadConfig(json);
      } else {
        console.log("not valid login");
        this.snackbar = true;
      }
    }
  }
};
</script>

<style scoped>
.headline1 {
  text-align: center;
  margin: 30px;
  color: #ffffff;
}
.login-card{
    background-repeat: no-repeat;
    background-size: contain;
    width: 650px;
    height: 450px;
    padding: 0px;
}

.login-card-inner{
        width: 300px;
    margin-right: 317px;
    margin-top: 65px;
}
</style>